import {
  ENDPOINT_REPORTING_COUNTRY,
  ENDPOINT_REPORTING_CUSTOM_COUNTRY,
  ENDPOINT_REPORTING_RISK_RATING_ALL,
  ENDPOINT_REPORTING_WATER,
  ENDPOINT_REPORTING_CUSTOM_WATER,
  ENDPOINT_REPORTING_CITY,
  ENDPOINT_REPORTING_CUSTOM_CITY,
  ENDPOINT_REPORTING_ANALYSIS,
  ENDPOINT_REPORTING_ASSET,
  ENDPOINT_REPORTING_SEARCH,
} from "@/common/constants/api";
import { encodeAllURLParameters } from "@/common/api.utilities";
import { httpGet, httpPost } from "@/services/api.service";

export { _getCountryReport as getCountryReport };
export { _getCustomCountryReport as getCustomCountryReport };
export { _getRiskRatingReport as getRiskRatingReport };
export { _getWaterReport as getWaterReport };
export { _getCustomWaterReport as getCustomWaterReport };
export { _getCityReport as getCityReport };
export { _getCustomCityReport as getCustomCityReport };
export { _getAnalysisReport as getAnalysisReport };
export { _getAssetReport as getAssetReport };
export { _getSearchReport as getSearchReport };

// params:
// from https://seeristreportmicroservice.docs.apiary.io/#reference/0/risk-rating-excel-sheet-report-for-all-country/risk-rating-excel-sheet-report-for-all-country
const _getReport = async (inputs, requestTimestamp) => {
  try {
    const options = {};
    let url = "";
    let result = null;
    switch (inputs.method) {
      case "GET":
        url = encodeAllURLParameters({
          baseEndpoint: inputs.endpoint,
          params: inputs.params,
        });
        options.method = "GET";
        result = JSON.parse(
          await httpGet({
            url: url,
          })
        );
        break;
      case "POST":
        url = inputs.endpoint;
        options.method = "POST";
        options.headers = { "Content-Type": "application/json" };
        options.body = JSON.stringify(inputs.params);
        result = JSON.parse(
          await httpPost({
            url: url,
            data: options.body,
          })
        );
        break;
      default:
        break;
    }

    let filename = "tmp.pdf";
    if (result.headers && result.headers["content-disposition"]) {
      const header = result.headers["content-disposition"];
      const parts = header.split(";");
      filename = parts[1].split("=")[1];
      filename = decodeURI(filename);
    }

    let file = `data:${result.headers["content-type"]};base64,${result.data}`;
    let a = document.createElement("a");
    a.href = file;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.error(error);
    Promise.reject(
      "Issue getting report in reporting.service.js: " + JSON.stringify(error)
    );
  } finally {
    return;
  }
};

const _getCountryReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_COUNTRY,
    method: "GET",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getCustomCountryReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_CUSTOM_COUNTRY,
    method: "POST",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getRiskRatingReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_RISK_RATING_ALL,
    method: "GET",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getWaterReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_WATER,
    method: "GET",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getCustomWaterReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_CUSTOM_WATER,
    method: "POST",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getCityReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_CITY,
    method: "GET",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getCustomCityReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_CUSTOM_CITY,
    method: "POST",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getAnalysisReport = async (id, requestTimestamp) => {
  if (!id) {
    console.error("Unable to get analysis report. No esId.");
    return;
  }
  let inputs = {
    endpoint: `${ENDPOINT_REPORTING_ANALYSIS}?id=${id}`,
    method: "GET",
    params: {},
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getAssetReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_ASSET,
    method: "GET",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};

const _getSearchReport = async (params, requestTimestamp) => {
  let inputs = {
    endpoint: ENDPOINT_REPORTING_SEARCH,
    method: "GET",
    params: params,
  };
  return await _getReport(inputs, requestTimestamp);
};
